module.exports = __webpack_public_path__ + "img/iso.2cec861e.jpg";